export default __webpack_public_path__ + "static/media/65.075ee178.jpeg";